import React from 'react';
import type { ThemeOptions as MuiThemeOptions } from '@eduvision/toolkit';
// import { defaultVariables} from '@eduvision/toolkit';


// interface CustomColors {
// 	someColor: string;
// }

// interface CustomVariables {
// 	someVar: string;
// }

// declare module '@eduvision/toolkit' {
// 	interface ButtonPropsVariantOverrides {
// 		customVariant: true;
// 	}
// 	interface Theme {
// 		customColors: CustomColors;
// 		customVariables: CustomVariables;
// 	}
// 	interface ThemeOptions {
// 		customColors?: CustomColors;
// 		customVariables?: CustomVariables;
// 	}
// }


const colors = {
	primary:'#6F2FEF',
	secondary:'#B2EFCE',
	textPrimary: '#3E3D3C',
	panelBg: '#F6FBFE'
};


export const customTheme = {
	palette: {
		primary: {
			main: colors.primary,
			light: '#FCEDF7',
			contrastText: '#ffffff'
		},
		secondary: {
			main: colors.secondary,
		},
		text:{
			primary: colors.textPrimary
		},
		background: {
			panel: colors.panelBg,
		},
	},
	
	
} as MuiThemeOptions;


